import WhiteLabelRedirect from './WhiteLabelRedirect';

export { WhiteLabelRedirect };
